<template>
  <div>
    <GlobalFooter class="i-copyright" :links="links" :copyright="copyright" />

    <img v-show="$route.path != '/login'" src="@/assets/msg.png" width="35px" height="35px"
      style="position: fixed ;bottom: 1% ;right: 1%;z-index: 99;" @click="showMessageCenter = !showMessageCenter">
    <iframe v-if="$route.path != '/login'" v-show="showMessageCenter" class="chat-main-window" src="/MessageCenter"
      ref="iframe" id="iframe" frameborder="0" scrolling="no"></iframe>



  </div>
</template>
<script>

import Setting from '@/setting';
import MessageCenter from '@/communication/MessageCenter';
import { mapState } from 'vuex';
import { getHeaderName, getMenuSider, getSiderSubmenu, getSiderOpenNames } from '@/libs/ab-system';


export default {
  name: 'i-copyright',
  computed: {
    ...mapState('admin/user', [
      'info'
    ]),
  },
  components: {
    MessageCenter
  },
  created() {
    console.log(111111)
    let that = this
    window.addEventListener('message', function (e) {
      if ("close" === e.data) {
        that.showMessageCenter = false
      }
      if ("open" === e.data) {
        that.showMessageCenter = true
      }
    })
    // 获取全部菜单
    this.$store.dispatch('admin/db/database', { user: true }).then((db) => {
      const menuList = db.get('userMenuList').value();
      // 通过顶部菜单的名字，获取子菜单
      console.log(menuList)
      if (menuList.length > 0) {
        window.localStorage.oa_currentMenuPath = '/' + menuList[0].key;

        const menuSider = getMenuSider(menuList, '/' + menuList[0].key);
        console.log(menuSider)
        this.$store.commit("admin/menu/setSider", menuSider);
        this.$store.commit('admin/menu/setHeaderName', '/' + menuList[0].key);
        this.$store.commit('admin/menu/setActivePath', this.$route.fullPath);
        // 切换菜单时，若子菜单是默认打开的则打开，若当前页面属于某个菜单也打开
        const openNames = getSiderOpenNames(this.$route.fullPath, menuSider, true);
        this.$store.commit('admin/menu/setOpenNames', openNames);
      }

    })

  },
  data() {
    return {
      links: [
        // {
        //     title: '官网',
        //     key: '官网',
        //     href: 'http://www.agilebpm.cn/',
        //     blankTarget: true
        // },
        // {
        //     title: '文档',
        //     key: '文档',
        //     href: 'http://www.agilebpm.cn/zh-cn/docs/',
        //     blankTarget: true
        // },
        // {
        //     title: 'GVP',
        //     key: 'Gitee',
        //     href: 'https://gitee.com/agile-bpm',
        //     blankTarget: true
        // }
      ],
      copyright: 'Copyright © 2023 ' + Setting.companyName,
      showMessageCenter: false,
    }
  }
}
</script>
<style lang="less">
.i-copyright {
  flex: 0 0 auto;

  &-hidden {
    display: none;
  }
}

.ivu-global-footer {
  margin: -10px 0 10px 0 !important;
  padding: 0 16px;
  text-align: center;
}


.chat-main-window {

  z-index: 999999;

  width: 20%;
  min-width: 325px;
  max-width: 414px;

  height: 70%;
  min-height: 510px;
  max-height: 896px;

  background: #fff;
  position: fixed;
  bottom: 65px;
  right: 100px;
  border-radius: 5px;
  box-shadow: 0px 1px 4px 0px rgba(221, 223, 235, 1);
  box-shadow: 2px 2px 2px 2px #dcdee2;
}
</style>
